import React, { Component } from 'react';
import { Box, Users, CreditCard } from 'react-feather';
import { adminloadTP, stopTimer, AuthenticatedUser } from '../../../api';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import BDBQueryCube from '../../../pages/pageParts/bdbQueryCube';
import TournamentPageTemplate from '../tournamentPageTemplate'
import PieAndLegend from './charts/pieAndLegend'

export class TournamentAdminDashboard extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.teamsTable = React.createRef();
        this.state = {
            loading: true,
            user: user,
            tData: {},
            menuJson: "",
            pid: params.pid
        }

    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            adminloadTP('none', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ pid: pid, tData: d2.tournamentPage, tUsers: d2.tUsers, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {

        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
    }
       
    eventsTotal() {
        const { tData } = this.state;
        return tData.events.length;
    }
    
    eventsPaid() {
        const { tUsers } = this.state;
        var total = 0;
        console.log(this.state)
        for (const tUser of tUsers) {
            total += tUser.events.filter(x=>x.isPaid).length
        }
        return total;
    }
    
    eventsPaidDollars() {
        const { tUsers } = this.state;
        var total = 0;
        for (const tUser of tUsers) {
            total += tUser.events.filter(x=>x.isPaid).reduce((a, b) => a + (b.fee || 0), 0)
        }
        return total;
    }

    compTotal() {
        const { tUsers } = this.state;
        return tUsers.filter(x=>x.isCompetitor).length;
    }

    competitorsReady() {
        const { tUsers } = this.state;

        return tUsers.filter(x=>x.isCompetitor && x.isAvailableComplete).length;    
    }
     
    compRegistered() {
        const { tUsers } = this.state;
        return tUsers.filter(x=>x.isCompetitor && x.isRegistered).length;
    }
    compNotAvailable() {
        const { tUsers } = this.state;
        return tUsers.filter(x=>x.isCompetitor && !x.isAvailableComplete).length;
    }

    judgeTotal() {
        const { tUsers } = this.state;
        return tUsers.filter(x=>x.isJudge).length;
    }

    judgeAvailable() {
        const { tUsers } = this.state;
        return tUsers.filter(x=>x.isJudge && x.isAvailableComplete).length;
    }

    getEventDistribution() {
        const {tData, tUsers } = this.state;
        const data = [];
        data.push(['Event', 'Competitors']);
        
        for(const tEvent of tData.events) {
            data.push(
            [tEvent.title, 
                tUsers.filter(y=>y.events.filter(x=>x.eventId === tEvent._id && x.isRegistered).length > 0).length]
            )
        }
        data.push(['UnRegistered', tUsers.filter(x=>x.isCompetitor && !x.isRegistered).length])
        console.log(data);
        return data;
    }
    
    getRoundAvailability() {
        const {tData, tUsers } = this.state;
        const data = [];
        data.push(['Round', 'Count']);

        for(const tRound of tData.rounds) {
            data.push(
            [tRound.title, 
                tUsers.filter(y=>y.rounds.filter(x=>x.roundId === tRound._id && x.isAvailable).length > 0).length]
            )
        }
        data.push(['Unavailable', tUsers.filter(x=>x.isJudge && x.rounds.filter(y=>y.isAvailable).length === 0).length])
        console.log(data);
        return data;
    }

    getMatchedTeams() {
        const {tData, tUsers } = this.state;
        const data = [];

        for(const tUser of tUsers) {
            for(const event of tUser.events.filter(x=> x.isRegistered && x.isPaid)) {
                const tEvent = tData.events.find(x=>x._id === event.eventId);
                if (tEvent && tEvent.teamSize > 1) {
                    if (event.partnerEmail) {
                        const partner = tUsers.find(x=>x.email === event.partnerEmail)
                        if (partner) {
                            const partnerEvent = partner.events.find(x=>x.eventId === event.eventId && x.isRegistered && x.isPaid) ;
                            if (partnerEvent && partnerEvent.partnerEmail) {
                                if (partnerEvent.partnerEmail === tUser.email && event.partnerEmail === partner.email) {
                                    if (data.find(x=>x.p1.userId === tUser.userId && x.event === tEvent.abbr)) continue;
                                    if (data.find(x=>x.p2.userId === tUser.userId && x.event === tEvent.abbr)) continue;
                                    if (data.find(x=>x.p1.userId === partner.userId && x.event === tEvent.abbr)) continue;
                                    if (data.find(x=>x.p2.userId === partner.userId && x.event === tEvent.abbr)) continue;
                                    data.push({event: tEvent.abbr, p1: tUser, p2: partner});
                                }
                            }                               
                        }
                    }
                } 
            }
        }
        return data;
    }

    onTeamsTableViewChange = () =>
    {
        const current = this.teamsTable.current;
        if (current)
        {
            const allData = current.getResolvedState().sortedData;
            this.setState({teamsTableCount: allData.length})
        }
    }

    render() {
        if (this.state.loading) { return null; }
        const { tData, user, tUsers, teamsTableCount } = this.state;

        stopTimer();
        const eventDistributionData = this.getEventDistribution()
        const roundAvailabiltyData = this.getRoundAvailability()
        const matchedTeamsData = this.getMatchedTeams();

        const recordsInfoText = `${teamsTableCount?teamsTableCount:0} filtered records`;

        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Dashboard - ${user.displayname}`} title3=""
            bcTitle="Dashboard" bcParents={[
                {name: tData.title, url: `/pages/tournament/${tData._id}`},
                {name: "Administration", url: `/tournament/admin/${tData._id}`}
            ]}
            >            
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Events" subtitle="Total Active" data={this.eventsTotal()} icon={<Box className="font-info" />} bg="bg-info"/>
                        </div>
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Events" subtitle="Total Paid" data={this.eventsPaid()} icon={<CreditCard className="font-info" />} bg="bg-info"/>
                        </div>
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Events" subtitle="Total Dollars" data={this.eventsPaidDollars()} icon={<CreditCard className="font-info" />} bg="bg-info"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Competitors" subtitle="Signed Up" data={this.compTotal()} link={`/tournament/admin/competitors/${tData._id}`} icon={<Users className="font-primary" />} bg="bg-primary"/>
                        </div>
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Competitors" subtitle="Registered" data={this.compRegistered()} link={`/tournament/admin/competitors/${tData._id}`} icon={<Users className="font-primary" />} bg="bg-primary"/>
                        </div>
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Competitors" subtitle="Waiting on someone"data={this.compNotAvailable()} link={`/tournament/admin/competitors/${tData._id}`} icon={<Users className="font-primary" />} bg="bg-primary"/>
                        </div>
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Competitors" subtitle="Ready" data={this.competitorsReady()} link={`/tournament/admin/competitors/${tData._id}`} icon={<Users className="font-primary" />} bg="bg-primary"/>
                        </div> 
                    </div>
                    <div className="row">
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Judges" subtitle="Signed Up" data={this.judgeTotal()} link={`/tournament/admin/judges/${tData._id}`} icon={<Users className="font-warning" />} bg="bg-warning"/>
                        </div>
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="Judges" subtitle="Available" data={this.judgeAvailable()} link={`/tournament/admin/judges/${tData._id}`} icon={<Users className="font-warning" />} bg="bg-warning"/>
                        </div>
                    </div>
                    <div className="row">   
                        <div className="col-xl-3 col-md-6 xl-50">
                            <BDBQueryCube title="User Activity" subtitle="Who's on" data={this.judgeAvailable()} link={`/tournament/admin/userActivity/${tData._id}`} icon={<Users className="font-warning" />} bg="bg-warning"/>
                        </div>                     
                    </div>

                    <div className="row">
                        <div className="col-xl-6 xl-100">
                            <PieAndLegend title="Event Registration" data={eventDistributionData}/>
                        </div>        
                        <div className="col-xl-6 xl-100">
                            <PieAndLegend title="Round Coverage" data={roundAvailabiltyData}/>
                        </div>
                    </div>    
                    <div className="row">            
                        <div className="col-xl-6 xl-100">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Unregistered Competitors</h5>
                                </div>
                                <div className="card-body">
                                    <div className="user-status table-responsive latest-order-table">
                                        <ReactTable
                                            filterable
                                            data={tUsers.filter(x=>x.status === 'Registering')}
                                            columns={[{
                                                Header: 'Competitor',
                                                accessor: 'displayname',
                                                maxWidth: 220,                                   
                                            },{
                                                Header: 'Status',
                                                accessor: 'status',
            
                                            }]}                                         
                                            defaultPageSize={12}
                                            showPagination={true}  
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>  
                        <div className="col-xl-6 xl-100">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Matched Teams</h5>
                                    <span>{recordsInfoText}</span>
                                </div>
                                <div className="card-body">
                                    <div className="user-status table-responsive latest-order-table">
                                        <ReactTable
                                            ref={this.teamsTable}
                                            filterable
                                            data={matchedTeamsData}
                                            columns={[{
                                                Header: 'Event',
                                                accessor: 'event',
                                            },{
                                                Header: 'Competitor',
                                                accessor: 'p1.displayname',
                                                maxWidth: 220,                                   
                                            },{
                                                Header: 'Competitor',
                                                accessor: 'p2.displayname',
                                                maxWidth: 220,                                   
                                            }]}                                         
                                            defaultPageSize={12}
                                            showPagination={true}  
                                            onFilteredChange={this.onTeamsTableViewChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>                       
                    </div>
                </div>
                </TournamentPageTemplate>

        )
    }
}
// javascript:void(0)

export default TournamentAdminDashboard
